var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { UuiMultiSelect, UuiSelectOption } from "@aonunited/react";
import './AonMultiSelect.component.scss';
var AonMultiSelect = function (_a) {
    var disabled = _a.disabled, label = _a.label, style = _a.style, state = _a.state, defaultValue = _a.defaultValue, handelChecked = _a.handelChecked, selectedList = _a.selectedList, enableSearch = _a.enableSearch;
    return (React.createElement("div", { className: "dropdownContainer aon-multi-select", style: __assign({ width: 300 }, style) },
        label && React.createElement("span", null, label),
        React.createElement("div", { className: "multiselect", style: { width: "100%", paddingTop: label ? "5px" : "0" } },
            React.createElement(UuiMultiSelect, { enableSearch: enableSearch, selectDeselectText: "Select All/Deselect All", defaultLabel: defaultValue, onSelectChange: handelChecked, disabled: disabled },
                React.createElement("div", { className: "multiselect-productContent" }, state === null || state === void 0 ? void 0 : state.map(function (option, index) {
                    var value = option.value;
                    return (React.createElement(UuiSelectOption, { className: "multiSelect-option", key: index, label: option.label, name: value, checked: selectedList.includes(value) }));
                }))))));
};
export { AonMultiSelect };
